import React from 'react';
import { styled, Switch } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';

const CustomSwitch = styled(
  ({ className, defaultChecked, disabled, checked, handlechange, ...props }) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      className={className}
      defaultChecked={defaultChecked}
      disabled={disabled}
      checked={checked}
      onChange={handlechange}
      {...props}
    />
  )
)(({ styles }) => ({
  width: '2.3em',
  height: '1.3em',
  padding: 0,
  border: '2px solid ' + ColorsV2.outline,
  borderRadius: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiSwitch-switchBase': {
    padding: 2,
    transition: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(1em)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: ColorsV2.acent,
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: '0.75em',
    height: '0.75em',
    color: ColorsV2.secondary,
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .MuiSwitch-track': {
    borderRadius: '15px',
    backgroundColor: ColorsV2.primary,
    opacity: 1,
    transition: 'background-color 500ms',
  },
  ...styles,
}));

export default CustomSwitch;
